import { PlaceholderArt } from "./PlaceholderArt";
import { ResponsiveImage } from "./ResponsiveImage";

interface ReleaseCoverProps {
  coverUrl?: string | null;
  label?: string;
  aspect?: "square" | "video" | "portrait";
  className?: string;
  alt?: string;
  loading?: "eager" | "lazy";
  /** Rendered width hint for srcset selection. */
  sizes?: string;
}

export function ReleaseCover({
  coverUrl,
  label = "[Upload cover art]",
  aspect = "square",
  className = "",
  alt,
  loading = "lazy",
  sizes = "(max-width: 640px) 92vw, (max-width: 1024px) 45vw, 400px",
}: ReleaseCoverProps) {
  if (!coverUrl) {
    return <PlaceholderArt label={label} aspect={aspect} className={className} />;
  }

  const aspectClass = aspect === "square" ? "aspect-square" : aspect === "video" ? "aspect-video" : "aspect-[3/4]";
  return (
    <div className={`relative overflow-hidden rounded-lg border hairline bg-temple ${aspectClass} ${className}`}>
      <ResponsiveImage
        src={coverUrl}
        alt={alt ?? label}
        sizes={sizes}
        priority={loading === "eager"}
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-obsidian/30 via-transparent to-transparent" aria-hidden />
    </div>
  );
}
